export default "__VITE_ASSET__21823ce9__"